const state = {
  isCollapsed: false,
  isMobile: false,
  openedPages: []
}

const mutations = {
  TOGGLE_COLLAPSE(state) {
    state.isCollapsed = !state.isCollapsed
  },
  SET_COLLAPSE(state, val) {
    state.isCollapsed = val
  },
  SET_MOBILE(state, val) {
    state.isMobile = val
  },
  ADD_OPENED_PAGE(state, page) {
    if (!state.openedPages.find(p => p.path === page.path)) {
      state.openedPages.push(page)
    }
  },
  REMOVE_OPENED_PAGE(state, path) {
    state.openedPages = state.openedPages.filter(p => p.path !== path)
  },
  SET_OPENED_PAGES(state, pages) {
    state.openedPages = pages
  }
}

// 菜单结构
const menuList = [
  {
    path: '/',
    title: '首页',
    icon: 'md-home'
  },
  {
    path: '/question',
    title: '题库管理',
    icon: 'md-help-circle'
  },
  {
    path: '/question-list',
    title: '题目列表',
    icon: 'md-list'
  },
  {
    path: '/questionnaire',
    title: '问卷管理',
    icon: 'md-clipboard'
  },
  {
    path: '/dashboard',
    title: '数据看板',
    icon: 'md-stats'
  }
]

const getters = {
  menuList: () => menuList
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
